//SearchResultsHeading.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as GetSearchResults from "./GetSearchResults";
import * as MailingLabels from "../Util/MailingLabels";
import * as MainMap from "../MainMap";
import * as Search from "./Search";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import { Button, Icon, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import React from "react";

//Render function.
interface iProps {
}

export function Render(props: iProps) {
   Util.logMsg("Top of SearchResultsHeading Render");
   const toolNames: string[] = Settings.searchResultsTools.slice(0);     //Clone array.
   const moreToolNames: string[] = Settings.searchResultsMoreTools.slice(0); //Clone array.
   const lay = Search.layers[Search.activeLayerIndex];

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      //Util.logMsg("SearchResultsHeading mounted");
   }, []);

   //Build top menu buttons.
   function getMenuButton(toolName: string): JSX.Element[] {
      const jsx: JSX.Element[] = [];

      const styles2: Default.iStyles = {
         button: { marginTop: 2, marginBottom: 2 },
      };

      const ti: Settings.iToolInfo = Settings.getToolInfo(toolName);
      const key: string = "searchResultsHeading_" + toolName;

      jsx.push(
         <Button key={key} style={styles2.button} variant="outlined" size="medium" color="info" onClick={() => handleClick(toolName)} title={ti.tip} aria-label={toolName}>
            <Icon color="action">{ti.iconName}</Icon>
            <span style={{ marginLeft: 4 }}></span>
            {ti.label}
         </Button>,
      );
      return jsx;
   }

   //Build more action menu items.
   function getMoreMenuItem(toolName: string): JSX.Element[] {
      const jsx: JSX.Element[] = [];
      const ti: Settings.iToolInfo = Settings.getToolInfo(toolName);
      const key: string = "searchResultsHeading_" + toolName;

      jsx.push(
         <MenuItem key={key} onClick={() => handleClick(toolName)}>
            <ListItemIcon><Icon style={{ color: ti.iconColor }}>{ti.iconName}</Icon></ListItemIcon>
            <ListItemText primary={ti.label} />
         </MenuItem>,
      );
      return jsx;
   }

   //Action button click event.
   function handleClick(tool: string) {
      setAnchorEl(null);

      if (tool === "Clear") {

         if (Search.layers.length === 1) {
            GetSearchResults.clearAllResults();
            DrawerMenu.closeTool();
            if (DrawerMenu.prevToolName === "Quick Search" ||
               DrawerMenu.prevToolName === "Select on Map" ||
               DrawerMenu.prevToolName === "Advanced Search") {
               DrawerMenu.prevToolClick(DrawerMenu.prevToolName);
            }

         } else {
            Search.layers.RemoveAt(Search.activeLayerIndex);
            GetSearchResults.setActiveLayerIndex();
            GetSearchResults.displayResults();
         }

      } else if (tool === "Zoom all") {
         const mbr: __esri.Extent = Util_App.addMarginToMBR(lay.zoomAllMBR, true);
         MainMap.activeView.goTo(mbr, { duration: 0 });

      } else if (tool === "Mailing Labels") {
         MailingLabels.show();

      } else if (tool === "CSV") {
         const layerName: string = Search.layers[Search.activeLayerIndex].name;
         const csvData: string = Util_App.build_csv(Search.layers[Search.activeLayerIndex]);
         Util.downloadCSV(layerName + ".csv", csvData);
      }
   }

   //Dropdown menu required functions.
   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

   function setMenuAnchor(event: React.MouseEvent<HTMLButtonElement>) {
      setAnchorEl(event.currentTarget);
   }
   function handleClose() {
      setAnchorEl(null);
   }

   //Only 1 record selected.
   if (lay.totRec === 1) {
      toolNames.Remove("Zoom all");
      //toolNames.Remove("Table view");
   }

   //Remove mailing labels for all but mailing label layer.
   if ((Settings.mailLabel.layerName !== lay.name) || (Settings.security.accessLevel < Settings.security.accessLevel_mailingLabels)) {
      moreToolNames.Remove("Mailing Labels");
   }

   //Render components
   const styles: Default.iStyles = {
      row1Container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around', flexWrap: 'wrap', marginTop: 5 },
      button: { marginTop: 2, marginBottom: 2 },
   };

   return (
      <div style={styles.row1Container}>
         <div>
            <Button style={styles.button} aria-controls="more-tools-menu" variant="outlined" color="info" onClick={setMenuAnchor} title="More result tools" aria-haspopup="true">
               <Icon color="action">more_vert</Icon>
               <span style={{ marginLeft: 4 }}></span>
               More
            </Button>

            <Menu id="more-tools-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
               {moreToolNames.map(function (toolName: string, i: number) {
                  if (!toolName.StartsWith(" ")) {
                     return (getMoreMenuItem(toolName));
                  }
               })}
            </Menu>
         </div>

         {toolNames.map(function (toolName: string, i: number) {
            if (!toolName.StartsWith(" ")) {
               return (getMenuButton(toolName));
            }
         })}
      </div>
   ); //end return.

} //end function.
